import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table,
  OffcanvasHeader,
  OffcanvasBody,
  Offcanvas,
  Row,
  Col,
  Card,
  Label,
  FormGroup,
  Input,
  InputGroup,
  ButtonGroup,
  CardHeader,
  InputGroupText,
  CardBody,
  Badge,
  Alert,
} from "reactstrap";
import restro from "../../../../../assets/orderingSystem/restrologo.png";
import PaymentTypeServices from "../../../../../services/OrderingServices/PaymentTypeService";
import { useReactToPrint } from "react-to-print";
import InvoiceSummary from "./InvoiceSummary";
import { PrintBill } from "../../../BillPrint/page/PrintBill";
import InvoiceSummaryMobile from "./InvoiceSummaryMobile";
import CreditModal from "../../../../../Components/Modal/CreditModal";

const ConfirmPayment = (props) => {
  const {
    isOpen,
    toggle,
    handleCheckout,
    billData,
    selectedPayment,
    setSelectedPayments,
    selectedPayments,
    handleApplyPromo,
    setPromoCode,
    promoCode,
    calculateTotals,
    handlePercentChange,
    Credit,
    discountPercent,
    setDiscountPercent,
    discountAmount,
    setDiscountAmount,
    promoSuccess,
    setPromoSuccess,
    promoError,
    setPromoError,
    selectedTable,
    setLastUpdated,
    user,
    selectedCustomer,
    orgInfo,
    toggleListModal,
    setCreditData,
    creditData,
    paymentAmounts,
    setPaymentAmounts,
    handleAmountChange,
    placedItems,
    responseData
  } = props;
  // console.log("🚀 ~ ConfirmPayment ~ selectedCustomer:", selectedCustomer);
 

  // Early return must be first
  // if (!isOpen || !billData || !selectedTable?.id) return null;

  const rawOrder = billData;
  // if (!rawOrder) return null;

  const itemsToShow =
    placedItems && placedItems.length > 0 ? placedItems : rawOrder.items || [];

  const { orderId, items } = rawOrder;
  console.log("🚀 ~ ConfirmPayment ~ items:", items);

  // All hooks below this point
  const printRef = useRef();
  const [data, setData] = useState([]);
  console.log("🚀 ~ ConfirmPayment ~ data:", data);
  const [selected, setSelected] = useState(selectedPayment || null);
  const [paymentStatus, setPaymentStatus] = useState(
    selectedPayment?.name ? "Paid" : "UnPaid"
  );
  const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);
  const [error, setError] = useState(null);
  const [isCreditOpen, setIsCreditOpen] = useState(false);

  const toggleInvoice = () => {
    setIsInvoiceOpen(!isInvoiceOpen);
  };

  const fetchData = async () => {
    try {
      const response = await PaymentTypeServices.getList();
      setData(response);
      setError(null);
    } catch (error) {
      console.error("Failed to fetch payment types:", error);
      setError("Unable to load payment methods. Please try again.");
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [isOpen]);

  useEffect(() => {
    if (selectedPayment) {
      setPaymentStatus("Paid");
    } else {
      setPaymentStatus("UnPaid");
    }
  }, [selectedPayment]);

  useEffect(() => {
    setSelected(selectedPayment);
  }, [selectedPayment]);

  useEffect(() => {
    if (selectedCustomer === null) {
      // Small delay ensures it updates after prop change
      setTimeout(() => {
        setDiscountPercent("");
        setDiscountAmount("");
        setPromoSuccess(false);
        setPromoError(null);
        setPromoCode("");
      }, 0);
    }
  }, [selectedCustomer]);

  const handleSelect = (payment) => {
    const isCredit = payment.name.toLowerCase().includes("credit");

    if (isCredit) {
      // Always select credit if not already
      setSelectedPayments((prev) => {
        if (!prev.some((item) => item.id === payment.id)) {
          return [...prev, payment];
        }
        return prev;
      });

      // Open modal for credit
      setIsCreditOpen(true);
    } else {
      // Toggle other payments
      setSelectedPayments((prev) => {
        const alreadySelected = prev.some((item) => item.id === payment.id);
        if (alreadySelected) {
          return prev.filter((item) => item.id !== payment.id);
        } else {
          return [...prev, payment];
        }
      });
    }
  };


  const toggleCreditModal = () => {
    setIsCreditOpen((prev) => !prev);
  };

  // For non-credit payment amounts
  const handleCreditAmountChange = (id, value) => {
    setPaymentAmounts((prev) => ({
      ...prev,
      [id]: value,
    }));
  };
  const totalPaid = useMemo(() => {
    let sum = 0;

    selectedPayments.forEach((item) => {
      const isCredit = item.name.toLowerCase().includes("credit");

      if (isCredit) {
        sum += parseFloat(creditData?.amount) || 0;
      } else {
        sum += parseFloat(paymentAmounts[item.id]) || 0;
      }
    });

    return sum;
  }, [selectedPayments, creditData, paymentAmounts]);

  const isValidAmount = () => {
    if (!selectedPayments?.length) return false; // No payment method selected

    // All fields must be filled & > 0
    const allValid = selectedPayments.every((item) => {
      const isCredit = item.name.toLowerCase().includes("credit");
      const amount = isCredit ? creditData?.amount : paymentAmounts[item.id];
      return amount && Number(amount) > 0;
    });

    if (!allValid) return false;

    // Enable only if sum matches bill total
    return (
      Number(totalPaid.toFixed(2)) === Number(calculateTotals.total.toFixed(2))
    );
  };
  const returnAmount = useMemo(() => {
    if (!calculateTotals.total) return 0; // if billAmount not loaded yet
    return totalPaid > calculateTotals.total
      ? totalPaid - calculateTotals.total
      : 0;
  }, [totalPaid, calculateTotals.total]);
  console.log(calculateTotals)

  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="end"
      backdropClassName="bg-dark bg-opacity-50"
      className="shadow-lg animate__animated animate__slideInRight bg-white rounded-start"
      id="offcanvasRight"
    >
      <OffcanvasHeader className="d-block d-sm-none">
        <div className="d-flex w-100 rounded-top">
          <button className="btn btn-sm btn-light" onClick={toggle}>
            <i className="bx bx-chevron-left"></i>
          </button>
          <div className="d-flex justify-content-between align-items-center w-100">
            <div className="text-center w-100">
              <h5 className="mb-0 fw-semibold">
                Order #{orderId} [ {selectedTable?.tableName}]
              </h5>
            </div>
            <button className="btn btn-sm btn-light" onClick={toggleInvoice}>
              Estimate 
            </button>
          </div>
        </div>
      </OffcanvasHeader>
      <div
        className="position-absolute d-none d-sm-block"
        style={{ left: "-40px", top: "10px" }}
      >
        <button className="btn btn-sm btn-light" onClick={toggle}>
          <i className="ri-close-line"></i>
        </button>
      </div>
      {/* Desktop Header */}
      <div className="d-none d-sm-flex gap-3 justify-content-start align-items-center p-3 shadow-sm rounded-top">
        <i className="ri-stack-line"></i>
        <h5 className="mb-0 fw-bold">
          Order #{orderId} • {selectedTable?.tableName}
        </h5>
      </div>
      <OffcanvasBody className="px-lg-4 px-2 py-3 bg-body-tertiary">
        <Row ref={printRef}>
          <Col md={7} lg={8}>
            <Card className="shadow-sm border-0 rounded-3">
              <CardHeader className="bg-light d-flex justify-content-between align-items-center rounded-top">
                <h5 className="mb-0 fw-semibold">Order Items</h5>
                <div
                  className="d-flex align-items-center gap-2 cursor-pointer"
                  onClick={toggleListModal}
                >
                  <i
                    className="ri-user-line fs-4 text-primary"
                    title="Select Customer"
                  ></i>
                  <div>
                    <div className="text-muted small">Customer</div>
                    <h6 className="mb-0 fw-bold">
                      {selectedCustomer?.firstName || "Select Customer"}
                    </h6>
                  </div>
                </div>
                <Badge color="info" pill>
                  {itemsToShow.length} Item{itemsToShow.length > 1 ? "s" : ""}
                </Badge>
              </CardHeader>
              <CardBody className="p-3">
                <div className="table-responsive rounded border mb-3 d-lg-block d-md-block d-none">
                  <Table
                    bordered
                    hover
                    responsive
                    className="align-middle mb-0"
                  >
                    <thead className="table-light text-center">
                      <tr>
                        <th className="text-level-3">#</th>
                        <th className="text-level-3">Item</th>
                        <th className="text-end text-level-3">Qty</th>
                        <th className="text-end text-level-3">Price (Rs)</th>
                        <th className="text-end text-level-3">Total (Rs)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemsToShow.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center text-level-3">
                            {index + 1}
                          </td>
                          <td className="text-level-2">{item?.productName}</td>
                          {item?.complimentaryQuantity > 0 ? (
                            <td className="text-end text-level-3">
                              {item?.complimentaryQuantity}
                            </td>
                          ) : (
                            <td className="text-end text-level-3">
                              {item?.quantity}
                            </td>
                          )}

                          <td className="text-end text-level-3">
                            {item?.productPrice?.toFixed(2)}
                          </td>
                          <td className="text-end text-level-3">
                            {(item?.quantity * item?.productPrice).toFixed(2)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                <Row className="gx-2 gy-3">
                  {/* Payment Mode */}
                  <Col
                    lg={{ size: 7, order: 1 }}
                    xl={{ size: 6, order: 1 }}
                    xs={{ size: 12, order: 2 }}
                  >
                    <Card>
                      <CardBody>
                        <h5 className="fw-semibold mb-3">Payment Mode</h5>
                        <Row className="g-2">
                          {data && (
                            <>
                              {/* Render the credit item */}
                              {(() => {
                                const creditItem = data.find((item) =>
                                  item.name.toLowerCase().includes("credit")
                                );
                                if (!creditItem) return null;

                                return (
                                  <Col xs="6" sm="4" key="credit">
                                    <Button
                                      color={
                                        selectedPayments.some(
                                          (item) =>
                                            item.name === creditItem.name
                                        )
                                          ? "primary"
                                          : "light"
                                      }
                                      className="w-100 text-capitalize d-flex justify-content-between align-items-center border shadow-sm"
                                      onClick={() => handleSelect(creditItem)}
                                    >
                                      <span className="text-truncate">
                                        {creditItem.name}
                                      </span>
                                    </Button>
                                  </Col>
                                );
                              })()}

                              {/* Render all other items except the credit item */}
                              {data
                                .filter(
                                  (item) =>
                                    !item.name.toLowerCase().includes("credit")
                                )
                                .map((item, index) => (
                                  <Col xs="6" sm="4" key={index}>
                                    <Button
                                      color={
                                        selectedPayments.some(
                                          (selected) =>
                                            selected.name === item.name
                                        )
                                          ? "primary"
                                          : "light"
                                      }
                                      className="w-100 text-capitalize d-flex justify-content-between align-items-center border shadow-sm"
                                      onClick={() => handleSelect(item)}
                                    >
                                      <span className="text-truncate">
                                        {item.name}
                                      </span>
                                    </Button>
                                  </Col>
                                ))}
                            </>
                          )}
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>

                  {/* Summary & Discounts */}
                  <Col
                    lg={{ size: 5, order: 2 }}
                    xs={{ size: 12, order: 1 }}
                    xl={{ size: 6, order: 2 }}
                  >
                    <div>
                      <div className="d-flex flex-column gap-4">
                        {/* Sub Total */}
                        <Row className="align-items-center">
                          {/* Payment Status */}
                          {/* <Col xs="6" className="mb-2">
                            <h6 className="mb-0 fw-bold">Payment mode</h6>
                          </Col>
                          <Col xs="6" className="text-end mb-2">
                            {selectedPayment?.name && (
                              <Badge
                                color={
                                  paymentStatus === "UnPaid"
                                    ? "danger"
                                    : "success"
                                }
                                className="text-capitalize"
                              >
                                {selectedPayment.name || "none"}
                              </Badge>
                            )}
                          </Col> */}

                          <Col xs="6" className="mb-2">
                            <h6 className="mb-0 fw-bold">Sub Total (Rs)</h6>
                          </Col>
                          <Col xs="6" className="text-end mb-2">
                            <span className="fw-bold text-success">
                              {calculateTotals.subTotal.toFixed(2)}
                            </span>
                          </Col>

                          <Col xs="12" md="6" className="mb-2">
                            <div className="d-flex justify-content-between align-content-center align-items-center">
                              <h6 className="fw-bold">Discount</h6>
                              {(discountPercent || discountAmount) &&
                                !promoSuccess && (
                                  <div className="text-end">
                                    <button
                                      className="btn btn-light btn-sm"
                                      onClick={() => {
                                        setDiscountPercent("");
                                        setDiscountAmount("");
                                        setLastUpdated(null);
                                      }}
                                    >
                                      <i className="ri-close-line"></i>
                                    </button>
                                  </div>
                                )}
                            </div>
                          </Col>

                          <Col xs="12" md="6" className="mb-2">
                            <div className="d-flex gap-2 justify-content-end align-items-center">
                              <div className="position-relative w-50">
                                <input
                                  type="number"
                                  placeholder="0"
                                  value={discountPercent}
                                  onChange={handlePercentChange}
                                  // min="0"
                                  max="100"
                                  step="0.01"
                                  className="form-control form-control-sm"
                                  disabled={promoSuccess}
                                />
                                <span className="position-absolute end-0 top-50 translate-middle-y pe-2 text-muted small">
                                  %
                                </span>
                              </div>
                              <i className="bx bx-link-alt text-muted"></i>
                              <div className="position-relative w-50">
                                <input
                                  type="number"
                                  placeholder="0.00"
                                  value={discountAmount}
                                  onChange={handleAmountChange} // ✅ use your handler here
                                  max={calculateTotals.subTotal}
                                  step="0.01"
                                  className="form-control form-control-sm"
                                  disabled={promoSuccess}
                                />

                                <span className="position-absolute end-0 top-50 translate-middle-y pe-2 text-muted small">
                                  Rs
                                </span>
                              </div>
                            </div>
                          </Col>

                          <Col xs="6" className="mb-2">
                            <h6 className="mb-0 fw-bold">Total Amount (Rs)</h6>
                          </Col>
                          <Col xs="6" className="text-end mb-2">
                            <span className="fw-bold text-success">
                              {calculateTotals.total.toFixed(2)}
                            </span>
                          </Col>

                          {selectedPayments?.map((item) => {
                            const isCredit = item.name
                              .toLowerCase()
                              .includes("credit");
                            return (
                              <React.Fragment key={item.id}>
                                <Col
                                  xs="6"
                                  className="mb-2 d-flex align-items-center"
                                >
                                  <h6 className="mb-0 fw-bold">{item?.name}</h6>
                                </Col>
                                <Col xs="6" className="text-end mb-2">
                                  <div className="d-flex gap-2">
                                    {isCredit && (
                                      <Button
                                        size="sm"
                                        outline
                                        color="danger"
                                        className="ms-2"
                                        onClick={() =>
                                          setSelectedPayments((prev) =>
                                            prev.filter((p) => p.id !== item.id)
                                          )
                                        }
                                      >
                                        <i class="bx bx-x"></i>
                                      </Button>
                                    )}
                                    <input
                                      type="text"
                                      inputMode="decimal" // or "numeric"
                                      pattern="[0-9]*"
                                      placeholder="Amount"
                                      className="form-control form-control-sm text-end"
                                      value={
                                        isCredit
                                          ? creditData?.amount || 0
                                          : paymentAmounts[item.id] || 0
                                      }
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        // allow only numbers + optional decimal
                                        if (/^\d*\.?\d*$/.test(value)) {
                                          isCredit
                                            ? setCreditData((prev) => ({
                                                ...prev,
                                                amount: value,
                                              }))
                                            : handleCreditAmountChange(
                                                item.id,
                                                value
                                              );
                                        }
                                      }}
                                    />
                                  </div>
                                </Col>
                              </React.Fragment>
                            );
                          })}
                          <hr />
                          <Col
                            xs={6}
                            className="mb-2 d-flex align-items-center"
                          >
                            <h6 className="mb-0 fw-bold">Return Amount (Rs)</h6>
                          </Col>
                          <Col xs={6} className="text-end mb-2">
                            <h6 className="mb-0 fw-bold text-success">
                              {returnAmount.toFixed(2)}
                            </h6>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>

          <Col
            md={5}
            lg={4}
            className="sticky-column d-lg-block d-sm-block d-none"
          >
            <InvoiceSummary
              orgInfo={orgInfo}
              user={user}
              selectedTable={selectedTable}
              orderId={orderId}
              items={itemsToShow}
              rawOrder={rawOrder}
              calculateTotals={calculateTotals}
              paymentStatus={paymentStatus}
              selected={selected}
              handleSelect={handleSelect}
              handleCheckout={handleCheckout}
              promoSuccess={promoSuccess}
              discountAmount={discountAmount}
              discountPercent={discountPercent}
              selectedCustomer={selectedCustomer}
              selectedPayment={selectedPayment}
              selectedPayments={selectedPayments}
              isValidAmount={isValidAmount}
              responseData={responseData}
            />
          </Col>
        </Row>
        <div className="p-2 rounded-3 border-2 shadow-sm bg-white position-sticky d-flex d-lg-none d-sm-none justify-content-between sticky-bottom align-items-center">
          <div>
            <p className="mb-0 text-muted small">Net sales amount</p>
            <h6 className="fw-bold mb-0 text-success">
              Rs {calculateTotals.total.toFixed(2)}
            </h6>
          </div>
          <Button
            color="success"
            className="px-4 shadow-sm"
            onClick={() => handleCheckout()}
            // disabled={!isValidAmount()}
          >
            Confirm
          </Button>
        </div>
      </OffcanvasBody>
      <InvoiceSummaryMobile
        isOpen={isInvoiceOpen}
        toggle={toggleInvoice}
        orgInfo={orgInfo}
        user={user}
        selectedTable={selectedTable}
        orderId={orderId}
        items={itemsToShow}
        calculateTotals={calculateTotals}
        paymentStatus={paymentStatus}
        selected={selected}
        handleSelect={handleSelect}
        handleCheckout={handleCheckout}
        promoSuccess={promoSuccess}
        discountAmount={discountAmount}
        discountPercent={discountPercent}
        selectedCustomer={selectedCustomer}
        selectedPayment={selectedPayment}
        rawOrder={rawOrder}
      />

      <CreditModal
        isOpen={isCreditOpen}
        toggle={toggleCreditModal}
        setCreditData={setCreditData}
        creditData={creditData}
        setIsCreditOpen={setIsCreditOpen}
        initialCustomer={selectedCustomer}
      />
    </Offcanvas>
  );
};

export default ConfirmPayment;
